export default __webpack_public_path__ + "static/media/17_oznaceni-lesa_web-min.da6ae6bd.jpg";